module.exports = __webpack_public_path__ + "static/media/cka_logo.f559e7c5.png";